var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { faChevronDown, faFilter, faSearch } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TableView } from "@yodlee/common-components";
import { Button, Checkbox, Icon, Input, Select, Tooltip, Typography } from "antd";
import { get } from "lodash";
import React from 'react';
import Highlighter from "react-highlight-words";
import InfiniteScroll from "react-infinite-scroll-component";
var calculateChannelOnlyRecord = function (selectedData) {
    var channels = [];
    var subBrands = [];
    selectedData.forEach(function (data) {
        if (data.type.name === "CHANNEL") {
            channels.push(data);
        }
        else if (data.type.name === "SUB_BRAND") {
            subBrands.push(data);
        }
    });
    return channels.filter(function (channel) { return !subBrands.find(function (subBrand) { return subBrand.channelId === channel.id; }); });
};
var COB_SELECT_POPUP_ID = "cob-slctn-ppup";
var CustomerSelectionView = /** @class */ (function (_super) {
    __extends(CustomerSelectionView, _super);
    function CustomerSelectionView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedRows: _this.props.selectedData.map(function (item) { return item.index.toString(); }),
            channelOnlyRecord: calculateChannelOnlyRecord(_this.props.selectedData),
            searchFilterKeys: {},
            pageNumber: 50,
            brandInfos: []
        };
        _this.searchFilterRefs = {};
        _this.componentDidMount = function () {
            var brandInfos = _this.props.brandInfos;
            var backend = [];
            var database = [];
            var dataCenter = [];
            brandInfos.forEach(function (brandInfo) {
                if (brandInfo.backendGroup && !backend.includes(brandInfo.backendGroup)) {
                    backend.push(brandInfo.backendGroup);
                }
                if (brandInfo.dataBase && !database.includes(brandInfo.dataBase)) {
                    database.push(brandInfo.dataBase);
                }
                if (brandInfo.dataCenter && !dataCenter.includes(brandInfo.dataCenter)) {
                    dataCenter.push(brandInfo.dataCenter);
                }
            });
            _this.setState({
                backend: backend,
                database: database,
                dataCenter: dataCenter,
                brandInfos: brandInfos
            });
        };
        _this.addChannelOnly = function (data) {
            var newChannelOnlyRecord = _this.state.channelOnlyRecord;
            newChannelOnlyRecord.push(data);
            var subBrands = _this.state.brandInfos.filter(function (brandInfo) { return brandInfo.channelId === data.id; }).map(function (brandInfo) { return brandInfo.index.toString(); });
            var newSelectedRows = _this.state.selectedRows.filter(function (item) { return !subBrands.includes(item); });
            _this.setState({
                channelOnlyRecord: newChannelOnlyRecord,
                selectedRows: newSelectedRows
            });
        };
        _this.removeChannelOnly = function (data) {
            var newChannelOnlyRecord = _this.state.channelOnlyRecord;
            var index = newChannelOnlyRecord.indexOf(data);
            newChannelOnlyRecord.splice(index, 1);
            var newSelectedRows = __spreadArray([], _this.state.selectedRows, true);
            _this.state.brandInfos.filter(function (brandInfo) { return brandInfo.channelId === data.id; }).map(function (brandInfo) { return brandInfo.index.toString(); }).forEach(function (subBrand) {
                if (!newSelectedRows.includes(subBrand)) {
                    newSelectedRows.push(subBrand);
                }
            });
            _this.setState({
                channelOnlyRecord: newChannelOnlyRecord,
                selectedRows: newSelectedRows,
            });
        };
        _this.handleSearch = function (selectedKeys, confirm, key) {
            var _a;
            var searchFilterKeys = _this.state.searchFilterKeys;
            confirm();
            _this.setState({
                searchFilterKeys: __assign(__assign({}, searchFilterKeys), (_a = {}, _a[key] = selectedKeys[0], _a)),
            });
        };
        _this.handleReset = function (clearFilters, key) {
            var _a;
            var searchFilterKeys = _this.state.searchFilterKeys;
            clearFilters();
            _this.setState({
                searchFilterKeys: __assign(__assign({}, searchFilterKeys), (_a = {}, _a[key] = undefined, _a)),
            });
        };
        _this.searchFilterProps = function (dataIndex, title, key, getValue) {
            if (getValue === void 0) { getValue = function (item) { return (item || "").toString(); }; }
            return ({
                filterDropdown: function (_a) {
                    var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                    return (React.createElement("div", { className: "padding-xs" },
                        React.createElement(Input, { className: "no-margin no-padding", ref: function (node) {
                                _this.searchFilterRefs[key] = node;
                            }, placeholder: "Search by ".concat(title.toLowerCase()), value: selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys[0], onChange: function (e) {
                                var value = e.target.value;
                                setSelectedKeys(value ? [e.target.value] : []);
                                !value && _this.handleReset(clearFilters, key);
                            }, onPressEnter: function () { return _this.handleSearch(selectedKeys, confirm, key); }, style: { width: 188, marginBottom: 8, display: 'block' }, allowClear: true })));
                },
                filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faSearch }); } }),
                onFilter: function (value, record) {
                    var newValue = get(record, dataIndex, "");
                    if (getValue) {
                        newValue = getValue(newValue);
                    }
                    return newValue.toString().toLowerCase().includes(value.toLowerCase());
                },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () { return _this.searchFilterRefs[key].select(); });
                    }
                },
                onClearFilter: function () { return _this.handleReset(function () { }, key); },
                render: function (text) {
                    var wordsToHighLight = undefined, currentFilter = _this.state.searchFilterKeys[key];
                    if (currentFilter)
                        wordsToHighLight = Array.isArray(currentFilter) ? currentFilter : [currentFilter];
                    return text && wordsToHighLight ?
                        React.createElement(Highlighter, { highlightStyle: { backgroundColor: 'yellow', padding: 0 }, searchWords: wordsToHighLight, autoEscape: true, textToHighlight: getValue(text) }) :
                        React.createElement(Tooltip, { title: getValue(text), placement: "bottomLeft" }, getValue(text));
                }
            });
        };
        _this.onSelect = function () {
            var _a = _this.props, brandInfos = _a.brandInfos, onSelectProps = _a.onSelect;
            var _b = _this.state, selectedRows = _b.selectedRows, channelOnlyRecord = _b.channelOnlyRecord;
            var ids = selectedRows.map(function (id) { return parseInt(id); });
            var data = brandInfos.filter(function (item) { return ids.includes(item.index); });
            if (onSelectProps) {
                onSelectProps(data, channelOnlyRecord);
            }
        };
        _this.filterData = function (selectedBackend, selectedDataCenter, selectedDatabase) {
            if (selectedBackend === void 0) { selectedBackend = []; }
            if (selectedDataCenter === void 0) { selectedDataCenter = []; }
            if (selectedDatabase === void 0) { selectedDatabase = []; }
            var brandInfos = _this.props.brandInfos;
            var data = brandInfos.filter(function (brandInfo) {
                if (selectedBackend.length > 0) {
                    if (!selectedBackend.includes(brandInfo.backendGroup || "")) {
                        return false;
                    }
                }
                if (selectedDataCenter.length > 0) {
                    if (!selectedDataCenter.includes(brandInfo.dataCenter || "")) {
                        return false;
                    }
                }
                if (selectedDatabase.length > 0) {
                    if (!selectedDatabase.includes(brandInfo.dataBase || "")) {
                        return false;
                    }
                }
                return true;
            });
            _this.setState({
                brandInfos: data
            });
        };
        _this.onRowSelect = function (newSelectedRows) {
            var _a = _this.state, channelOnlyRecord = _a.channelOnlyRecord, brandInfos = _a.brandInfos, selectedRows = _a.selectedRows;
            if (newSelectedRows.length === 0) {
                _this.setState({
                    selectedRows: newSelectedRows,
                    channelOnlyRecord: []
                });
            }
            else {
                var finalSelectedRows_1 = __spreadArray([], newSelectedRows, true);
                var finalChannelOnlyRecord_1 = __spreadArray([], channelOnlyRecord.filter(function (item) { return finalSelectedRows_1.includes(item.index.toString()); }), true);
                var uniques = newSelectedRows.filter(function (item) { return !selectedRows.includes(item); });
                uniques.forEach(function (unique) {
                    var brand = brandInfos.find(function (brand) { return brand.index.toString() === unique; });
                    if (brand && brand.type.name === "CHANNEL") {
                        var subBrands = brandInfos.filter(function (subBrand) { return subBrand.channelId === brand.id; }).map(function (subBrand) { return subBrand.index.toString(); });
                        subBrands.forEach(function (subBrand) {
                            if (!finalSelectedRows_1.includes(subBrand)) {
                                finalSelectedRows_1.push(subBrand);
                            }
                        });
                    }
                    else if (brand && brand.type.name === "SUB_BRAND") {
                        var channel = brandInfos.find(function (channel) { return channel.id === brand.channelId; });
                        if (channel) {
                            finalChannelOnlyRecord_1 = finalChannelOnlyRecord_1.filter(function (channel) { return channel.index.toString() !== channel.index.toString(); });
                        }
                    }
                });
                _this.setState({
                    selectedRows: finalSelectedRows_1,
                    channelOnlyRecord: finalChannelOnlyRecord_1
                });
            }
        };
        _this.render = function () {
            var _a = _this.state, channelOnlyRecord = _a.channelOnlyRecord, pageNumber = _a.pageNumber, dataCenter = _a.dataCenter, database = _a.database, backend = _a.backend, brandInfos = _a.brandInfos, selectedRows = _a.selectedRows;
            var onCancel = _this.props.onCancel;
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "padding-md-horizontal" },
                    React.createElement("br", null),
                    React.createElement(Typography.Title, { level: 2, className: "color-blue-5" }, "Select customers")),
                backend && dataCenter && database &&
                    React.createElement("div", { style: { height: "500px", overflow: "scroll" }, id: "scrollableDiv" },
                        React.createElement(InfiniteScroll, { dataLength: pageNumber, next: function () {
                                var length = brandInfos.length;
                                if (pageNumber > length) {
                                    _this.setState({ pageNumber: pageNumber + 50 });
                                }
                                else {
                                    _this.setState({ pageNumber: pageNumber + 50 });
                                }
                                return;
                            }, hasMore: pageNumber < brandInfos.length, scrollableTarget: "scrollableDiv", loader: React.createElement("span", null) },
                            React.createElement("span", { className: "hide-pagination only-header-border" },
                                React.createElement(TableView, { selectedRowKeys: selectedRows, tableSetting: false, getRowKey: function (data) { return data.index.toString(); }, data: brandInfos, onColumnChange: function () { }, suffix: React.createElement(Select, { id: COB_SELECT_POPUP_ID, allowClear: true, placeholder: "Filter by data groups", mode: "multiple", showSearch: true, maxTagCount: 0, getPopupContainer: function () { return document.getElementById(COB_SELECT_POPUP_ID) || document.body; }, maxTagPlaceholder: function (values) { return "".concat(values.length, " selected"); }, dropdownClassName: "checked-select", style: { minWidth: "300px" }, showArrow: true, onChange: function (data) {
                                            var selectedDataCenter = [];
                                            var selectedDatabase = [];
                                            var selectedBackend = [];
                                            (data || []).forEach(function (value) {
                                                if (value.startsWith("dataCenter_")) {
                                                    selectedDataCenter.push(value.replace("dataCenter_", ""));
                                                }
                                                else if (value.startsWith("backend_")) {
                                                    selectedBackend.push(value.replace("backend_", ""));
                                                }
                                                else if (value.startsWith("database_")) {
                                                    selectedDatabase.push(value.replace("database_", ""));
                                                }
                                            });
                                            _this.filterData(selectedBackend, selectedDataCenter, selectedDatabase);
                                        }, suffixIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faChevronDown }); } }) },
                                        React.createElement(Select.OptGroup, { label: "DATA CENTER" }, dataCenter === null || dataCenter === void 0 ? void 0 : dataCenter.map(function (searchByOption) {
                                            return React.createElement(Select.Option, { key: "dataCenter_".concat(searchByOption), value: "dataCenter_".concat(searchByOption) }, searchByOption);
                                        })),
                                        React.createElement(Select.OptGroup, { label: "BACKEND" }, backend === null || backend === void 0 ? void 0 : backend.map(function (searchByOption) {
                                            return React.createElement(Select.Option, { key: "backend_".concat(searchByOption), value: "backend_".concat(searchByOption) }, searchByOption);
                                        })),
                                        React.createElement(Select.OptGroup, { label: "DATABASE" }, database === null || database === void 0 ? void 0 : database.map(function (searchByOption) {
                                            return React.createElement(Select.Option, { key: "database_".concat(searchByOption), value: "database_".concat(searchByOption) }, searchByOption);
                                        }))), onRowSelect: _this.onRowSelect, quickActions: [], rowDensity: "small", pagination: { pageSize: pageNumber }, columns: [
                                        {
                                            title: "Type",
                                            key: "type",
                                            dataIndex: "type.name",
                                            minWidth: 100,
                                            sorter: function (a, b) {
                                                var _a, _b, _c, _d;
                                                var firstType = ((_b = (_a = a.type) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || "";
                                                var secondType = ((_d = (_c = b.type) === null || _c === void 0 ? void 0 : _c.name) === null || _d === void 0 ? void 0 : _d.toLowerCase()) || "";
                                                return firstType === secondType ? 0 : secondType > firstType ? -1 : 1;
                                            },
                                            filters: [{ text: "Channel", value: "CHANNEL" }, { text: "Cobrand", value: "COBRAND" }, { text: "Sub-Brand", value: "SUB_BRAND" }],
                                            filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faFilter }); } }),
                                            onFilter: function (value, record) { return record.type.name === value ? true : false; }
                                        },
                                        {
                                            title: "Channel only",
                                            key: "channelOnly",
                                            dataIndex: "",
                                            minWidth: 100,
                                            render: function (data, record) {
                                                return (record.type.name === "CHANNEL" ?
                                                    React.createElement(Checkbox, { disabled: !selectedRows.includes(record.index.toString()), checked: channelOnlyRecord.find(function (d) { return d === data; }), onChange: function (e) {
                                                            if (e.target.checked) {
                                                                _this.addChannelOnly(data);
                                                            }
                                                            else {
                                                                _this.removeChannelOnly(data);
                                                            }
                                                        } }) :
                                                    React.createElement("span", null));
                                            }
                                        },
                                        __assign({ title: "Customer ID", key: "id", dataIndex: "id", minWidth: 180, sorter: function (a, b) { return a.id - b.id; } }, _this.searchFilterProps("id", "Customer ID", "id")),
                                        __assign({ title: "Name", key: "name", dataIndex: "name", minWidth: 100, sorter: function (a, b) {
                                                var _a, _b;
                                                var firstName = ((_a = a.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
                                                var secondName = ((_b = b.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || "";
                                                return firstName === secondName ? 0 : secondName > firstName ? -1 : 1;
                                            } }, _this.searchFilterProps("name", "Name", "name")),
                                        {
                                            title: "Data center",
                                            key: "dataCenter",
                                            dataIndex: "dataCenter",
                                            minWidth: 180,
                                            sorter: function (a, b) {
                                                var _a, _b;
                                                var firstDataCenter = ((_a = a.dataCenter) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
                                                var secondDataCenter = ((_b = b.dataCenter) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || "";
                                                return firstDataCenter === secondDataCenter ? 0 : secondDataCenter > firstDataCenter ? -1 : 1;
                                            },
                                            filters: dataCenter === null || dataCenter === void 0 ? void 0 : dataCenter.map(function (item) { return ({ text: item, value: item }); }),
                                            filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faFilter }); } }),
                                            onFilter: function (value, record) { return record.dataCenter === value ? true : false; }
                                        },
                                        {
                                            title: "Backend",
                                            key: "backend",
                                            dataIndex: "backendGroup",
                                            minWidth: 100,
                                            sorter: function (a, b) {
                                                var _a, _b;
                                                var firstBackend = ((_a = a.backendGroup) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
                                                var secondBackend = ((_b = b.backendGroup) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || "";
                                                return firstBackend === secondBackend ? 0 : secondBackend > firstBackend ? -1 : 1;
                                            },
                                            filters: backend === null || backend === void 0 ? void 0 : backend.map(function (item) { return ({ text: item, value: item }); }),
                                            filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faFilter }); } }),
                                            onFilter: function (value, record) { return record.backendGroup === value ? true : false; }
                                        },
                                        {
                                            title: "Database",
                                            key: "database",
                                            dataIndex: "dataBase",
                                            minWidth: 100,
                                            sorter: function (a, b) {
                                                var _a, _b;
                                                var firstDatabase = ((_a = a.dataBase) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
                                                var secondDatabase = ((_b = b.dataBase) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || "";
                                                return firstDatabase === secondDatabase ? 0 : secondDatabase > firstDatabase ? -1 : 1;
                                            },
                                            filters: database === null || database === void 0 ? void 0 : database.map(function (item) { return ({ text: item, value: item }); }),
                                            filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faFilter }); } }),
                                            onFilter: function (value, record) { return record.dataBase === value ? true : false; }
                                        }
                                    ] })))),
                React.createElement("div", { className: "background-gray-1 align-right padding-lg border-top" },
                    React.createElement(Button, { type: "danger", onClick: onCancel }, "Cancel"),
                    React.createElement("span", { className: "margin-left-sm" }),
                    React.createElement(Button, { type: "primary", onClick: _this.onSelect }, "Add selected"))));
        };
        return _this;
    }
    return CustomerSelectionView;
}(React.Component));
export default CustomerSelectionView;
//# sourceMappingURL=customer-selection-view.js.map